"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Body = require("../Body");

var _helpers = require("../../../helpers");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var importance = {
  high: (0, _helpers.color)('black100'),
  medium: (0, _helpers.color)('black80'),
  low: (0, _helpers.color)('black60')
};

var P = _styledComponents.default.p.withConfig({
  displayName: "P",
  componentId: "sc-1ninpix-0"
})(["", ";margin:0 0 1.5rem;color:", ";@media ", "{margin:0 0 1rem;}"], _Body.bodyStyle, function (p) {
  return importance[p.importance || 'high'];
}, (0, _helpers.breakpoint)('maxMobile'));

var _default = P;
exports.default = _default;